import React from "react";

const Categories = ({ isGuest, title, banner, user, data }) => {
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    const list = data.filter((item) =>
      item.allow.includes(isGuest ? "guest" : "user")
    );
    setCategories(list);
  }, [data]);

  return (
    <div className="help-categories-wrapper">
      <div className="mt-3 row">
        <div class="btn col-auto text-left">
          <h3 className="font-weight-bold m-0">{title}</h3>
        </div>
        <div className="col pl-0"></div>
      </div>
      <ul className="category-tiles pl-3 row">
        {categories.map((Category, index) => (
          <Category.Card
            category={Category}
            isGuest={isGuest}
            user={user}
            banner={banner}
          />
        ))}
      </ul>
    </div>
  );
};

export default React.memo(Categories);
